/*
 * @Author: 梁洪刚
 * @CreatDate: 2021-03-31 13:57:32
 * @Describe: 省略号组件
 */

import copy from 'copy-to-clipboard'
import React, { useEffect, useRef, useState } from 'react'

import Popover from '../popover'
import Tooltip from '../tooltip'

import CopySVG from './Svg/CopySVG'
import TickSVG from './Svg/TickSVG'
import './index.less'

const tolerance = 0 // In px. Depends on the font you are using

const isEllipsisActive = (e) => {
  if (e.offsetWidth === e.scrollWidth && e.offsetHeight === e.scrollHeight) {
    let styleStr = 'overflow:visible; '
    if (!e?.parentNode?.getAttribute('style')?.includes('width')) {
      styleStr += 'max-width:100%;'
    }
    e.parentNode.setAttribute('style', styleStr)
  }
  return e.offsetWidth + tolerance < e.scrollWidth || e.offsetHeight < e.scrollHeight
}

export default (props) => {
  let {
    _popover = props.Popover, // `Popover` or `Tooltip` ?
    title, // in most cases for `Tooltip`
    content, // in most cases for `Popover`
    className,
    style,
    widthLimit, // width trigger value
    _lines = props.lines !== 1 && props.lines, // number or lines, default 1 line;
    children, // children Node
    emptyText, // default: null
    _copyable = props.copyable, // copy function
    prefix, // 前缀dom
    suffix, // 后缀dom
  } = props

  // allow visible or not state
  const [flag, setFlag] = useState(true)
  // visible[Tooltip/Popover] state
  const [tipVisible, setTipVisible] = useState(false)
  // copy animation state
  const [hasCopy, setHasCopy] = useState(false)
  const [lineHeight, setLineHeight] = useState()

  const elementRef = useRef()

  useEffect(() => {
    elementRef.current && isEllipsisActive(elementRef.current)
      ? setFlag(true)
      : (setFlag(false), setTipVisible(false))

    if (elementRef.current) {
      setLineHeight(getComputedStyle(elementRef.current, null).getPropertyValue('line-height'))
    }
  })

  // original Node
  const inner = typeof children === 'string' ? children : _popover ? content : title

  // for className
  const getClassName = () => {
    return `overflow min-width-0 ${_lines ? 'ellipsis-wrap' : 'ellipsis-nowrap'} ${className || ''}`
  }

  // Tooltip.trigger(default 'hover') ==trigger==> onVisibleChange(visible)
  const handleVisibleChange = (visible) => {
    // const { onVisibleChange } = props;
    // onVisibleChange(visible);
    flag && setTipVisible(visible)
  }

  // onClick Copy Button
  const handleCopy = (innerText) => {
    copy(innerText)
    setHasCopy(!hasCopy)
    setTimeout(() => {
      setHasCopy(false)
    }, 1000)
  }

  const renderNode = () => {
    const popoverNode = (
      <Popover
        {...props}
        content={content || children}
        visible={tipVisible}
        onVisibleChange={(visible) => handleVisibleChange(visible)}
      >
        <div className={className} style={{ WebkitLineClamp: _lines }} ref={elementRef}>
          {children || content}
        </div>
      </Popover>
    )

    const tooltipNode = (
      <Tooltip
        {...props}
        title={title || children}
        visible={tipVisible}
        onVisibleChange={(visible) => handleVisibleChange(visible)}
      >
        <div className={className} style={{ WebkitLineClamp: _lines }} ref={elementRef}>
          {children || title}
        </div>
      </Tooltip>
    )

    return _popover ? popoverNode : tooltipNode
  }

  return (
    <>
      <div
        className="tntd-ellipsis"
        style={{
          ...style,
          maxWidth: widthLimit,
        }}
      >
        {/* prefix */}
        {prefix && prefix}
        {/* content */}
        <div className={getClassName()}>{inner ? renderNode() : emptyText}</div>
        {/* suffix */}
        {suffix && suffix}
        {/* copyable button */}
        {inner && _copyable && lineHeight && (
          <div
            className="svg-button"
            style={{
              height: lineHeight,
            }}
            onClick={() => handleCopy(elementRef.current.innerText)}
          >
            {!hasCopy ? (
              <CopySVG
                style={{
                  height: lineHeight,
                }}
              />
            ) : (
              <TickSVG
                style={{
                  height: lineHeight,
                }}
              />
            )}
          </div>
        )}
      </div>
    </>
  )
}
